import { observable } from 'mobx';
import { ZERO } from '../utils/constant';

import back from '../static/icon/back.png';

import plane_02_03_02_up from '../static/house/plane/02_03_02_up.png';
import plane_02_03_02_down from '../static/house/plane/02_03_02_down.png';
import plane_02_05_01 from '../static/house/plane/02_05_01.png';
import plane_02_05_02 from '../static/house/plane/02_05_02.png';
import plane_02_09_02 from '../static/house/plane/02_09_02.png';

import plane_03_01_01 from '../static/house/plane/03_01_01.png';
import plane_03_01_02 from '../static/house/plane/03_01_02.png';
import plane_03_01_03 from '../static/house/plane/03_01_03.png';
import plane_03_01_05 from '../static/house/plane/03_01_05.png';
import plane_03_01_06 from '../static/house/plane/03_01_06.png';
import plane_03_01_07 from '../static/house/plane/03_01_07.png';
import plane_03_01_08 from '../static/house/plane/03_01_08.png';
import plane_03_01_09 from '../static/house/plane/03_01_09.png';

import plane_03_05_01 from '../static/house/plane/03_05_01.png';
import plane_03_05_02 from '../static/house/plane/03_05_02.png';
import plane_03_05_03 from '../static/house/plane/03_05_03.png';
import plane_03_05_05 from '../static/house/plane/03_05_05.png';
import plane_03_05_06 from '../static/house/plane/03_05_06.png';
import plane_03_05_07 from '../static/house/plane/03_05_07.png';
import plane_03_05_08 from '../static/house/plane/03_05_08.png';
import plane_03_05_09 from '../static/house/plane/03_05_09.png';

import plane_03_07_01 from '../static/house/plane/03_07_01.png';
import plane_03_07_02 from '../static/house/plane/03_07_02.png';
import plane_03_07_03 from '../static/house/plane/03_07_03.png';
import plane_03_07_05 from '../static/house/plane/03_07_05.png';
import plane_03_07_06 from '../static/house/plane/03_07_06.png';
import plane_03_07_07 from '../static/house/plane/03_07_07.png';
import plane_03_07_08 from '../static/house/plane/03_07_08.png';
import plane_03_07_09 from '../static/house/plane/03_07_09.png';

import plane_01_A1_102 from '../static/house/plane/01_A1_102.png';   // 梯屋
import plane_01_A1_03 from '../static/house/plane/01_A1_03.png';
import plane_01_A1_02 from '../static/house/plane/01_A1_02.png';
import plane_01_A1_01 from '../static/house/plane/01_A1_01.png';
import plane_01_A1__01 from '../static/house/plane/01_A1_-01.png';   // 负一层

import plane_01_A5_102 from '../static/house/plane/01_A5_102.png';
import plane_01_A5_03 from '../static/house/plane/01_A5_03.png';
import plane_01_A5_02 from '../static/house/plane/01_A5_02.png';
import plane_01_A5_01 from '../static/house/plane/01_A5_01.png';
import plane_01_A5__01 from '../static/house/plane/01_A5_-01.png';

import plane_01_A7_102 from '../static/house/plane/01_A7_102.png';
import plane_01_A7_03 from '../static/house/plane/01_A7_03.png';
import plane_01_A7_02 from '../static/house/plane/01_A7_02.png';
import plane_01_A7_01 from '../static/house/plane/01_A7_01.png';
import plane_01_A7__01 from '../static/house/plane/01_A7_-01.png';

import household3D_03_01_01_00 from '../static/house/household3D/03_01_01/00.jpg';
import household3D_03_01_01_01 from '../static/house/household3D/03_01_01/01.jpg';
import household3D_03_01_01_02 from '../static/house/household3D/03_01_01/02.jpg';
import household3D_03_01_01_03 from '../static/house/household3D/03_01_01/03.jpg';
import household3D_03_01_01_04 from '../static/house/household3D/03_01_01/04.jpg';
import household3D_03_01_01_05 from '../static/house/household3D/03_01_01/05.jpg';
import household3D_03_01_01_06 from '../static/house/household3D/03_01_01/06.jpg';
import household3D_03_01_01_07 from '../static/house/household3D/03_01_01/07.jpg';
import household3D_03_01_01_08 from '../static/house/household3D/03_01_01/08.jpg';
import household3D_03_01_01_09 from '../static/house/household3D/03_01_01/09.jpg';
import household3D_03_01_01_10 from '../static/house/household3D/03_01_01/10.jpg';
import household3D_03_01_01_11 from '../static/house/household3D/03_01_01/11.jpg';
import household3D_03_01_01_12 from '../static/house/household3D/03_01_01/12.jpg';
import household3D_03_01_01_13 from '../static/house/household3D/03_01_01/13.jpg';
import household3D_03_01_01_14 from '../static/house/household3D/03_01_01/14.jpg';
import household3D_03_01_01_15 from '../static/house/household3D/03_01_01/15.jpg';
import household3D_03_01_01_16 from '../static/house/household3D/03_01_01/16.jpg';
import household3D_03_01_01_17 from '../static/house/household3D/03_01_01/17.jpg';
import household3D_03_01_01_18 from '../static/house/household3D/03_01_01/18.jpg';
import household3D_03_01_01_19 from '../static/house/household3D/03_01_01/19.jpg';
import household3D_03_01_01_20 from '../static/house/household3D/03_01_01/20.jpg';
import household3D_03_01_01_21 from '../static/house/household3D/03_01_01/21.jpg';
import household3D_03_01_01_22 from '../static/house/household3D/03_01_01/22.jpg';
import household3D_03_01_01_23 from '../static/house/household3D/03_01_01/23.jpg';
import household3D_03_01_01_24 from '../static/house/household3D/03_01_01/24.jpg';
import household3D_03_01_01_25 from '../static/house/household3D/03_01_01/25.jpg';
import household3D_03_01_01_26 from '../static/house/household3D/03_01_01/26.jpg';
import household3D_03_01_01_27 from '../static/house/household3D/03_01_01/27.jpg';
import household3D_03_01_01_28 from '../static/house/household3D/03_01_01/28.jpg';
import household3D_03_01_01_29 from '../static/house/household3D/03_01_01/29.jpg';
import household3D_03_01_01_30 from '../static/house/household3D/03_01_01/30.jpg';
import household3D_03_01_01_31 from '../static/house/household3D/03_01_01/31.jpg';
import household3D_03_01_01_32 from '../static/house/household3D/03_01_01/32.jpg';
import household3D_03_01_01_33 from '../static/house/household3D/03_01_01/33.jpg';
import household3D_03_01_01_34 from '../static/house/household3D/03_01_01/34.jpg';
import household3D_03_01_01_35 from '../static/house/household3D/03_01_01/35.jpg';

import household3D_03_01_02_00 from '../static/house/household3D/03_01_02/00.jpg';
import household3D_03_01_02_01 from '../static/house/household3D/03_01_02/01.jpg';
import household3D_03_01_02_02 from '../static/house/household3D/03_01_02/02.jpg';
import household3D_03_01_02_03 from '../static/house/household3D/03_01_02/03.jpg';
import household3D_03_01_02_04 from '../static/house/household3D/03_01_02/04.jpg';
import household3D_03_01_02_05 from '../static/house/household3D/03_01_02/05.jpg';
import household3D_03_01_02_06 from '../static/house/household3D/03_01_02/06.jpg';
import household3D_03_01_02_07 from '../static/house/household3D/03_01_02/07.jpg';
import household3D_03_01_02_08 from '../static/house/household3D/03_01_02/08.jpg';
import household3D_03_01_02_09 from '../static/house/household3D/03_01_02/09.jpg';
import household3D_03_01_02_10 from '../static/house/household3D/03_01_02/10.jpg';
import household3D_03_01_02_11 from '../static/house/household3D/03_01_02/11.jpg';
import household3D_03_01_02_12 from '../static/house/household3D/03_01_02/12.jpg';
import household3D_03_01_02_13 from '../static/house/household3D/03_01_02/13.jpg';
import household3D_03_01_02_14 from '../static/house/household3D/03_01_02/14.jpg';
import household3D_03_01_02_15 from '../static/house/household3D/03_01_02/15.jpg';
import household3D_03_01_02_16 from '../static/house/household3D/03_01_02/16.jpg';
import household3D_03_01_02_17 from '../static/house/household3D/03_01_02/17.jpg';
import household3D_03_01_02_18 from '../static/house/household3D/03_01_02/18.jpg';
import household3D_03_01_02_19 from '../static/house/household3D/03_01_02/19.jpg';
import household3D_03_01_02_20 from '../static/house/household3D/03_01_02/20.jpg';
import household3D_03_01_02_21 from '../static/house/household3D/03_01_02/21.jpg';
import household3D_03_01_02_22 from '../static/house/household3D/03_01_02/22.jpg';
import household3D_03_01_02_23 from '../static/house/household3D/03_01_02/23.jpg';
import household3D_03_01_02_24 from '../static/house/household3D/03_01_02/24.jpg';
import household3D_03_01_02_25 from '../static/house/household3D/03_01_02/25.jpg';
import household3D_03_01_02_26 from '../static/house/household3D/03_01_02/26.jpg';
import household3D_03_01_02_27 from '../static/house/household3D/03_01_02/27.jpg';
import household3D_03_01_02_28 from '../static/house/household3D/03_01_02/28.jpg';
import household3D_03_01_02_29 from '../static/house/household3D/03_01_02/29.jpg';
import household3D_03_01_02_30 from '../static/house/household3D/03_01_02/30.jpg';
import household3D_03_01_02_31 from '../static/house/household3D/03_01_02/31.jpg';
import household3D_03_01_02_32 from '../static/house/household3D/03_01_02/32.jpg';
import household3D_03_01_02_33 from '../static/house/household3D/03_01_02/33.jpg';
import household3D_03_01_02_34 from '../static/house/household3D/03_01_02/34.jpg';
import household3D_03_01_02_35 from '../static/house/household3D/03_01_02/35.jpg';

import household3D_02_09_02_00 from '../static/house/household3D/02_09_02/00.jpg';
import household3D_02_09_02_01 from '../static/house/household3D/02_09_02/01.jpg';
import household3D_02_09_02_02 from '../static/house/household3D/02_09_02/02.jpg';
import household3D_02_09_02_03 from '../static/house/household3D/02_09_02/03.jpg';
import household3D_02_09_02_04 from '../static/house/household3D/02_09_02/04.jpg';
import household3D_02_09_02_05 from '../static/house/household3D/02_09_02/05.jpg';
import household3D_02_09_02_06 from '../static/house/household3D/02_09_02/06.jpg';
import household3D_02_09_02_07 from '../static/house/household3D/02_09_02/07.jpg';
import household3D_02_09_02_08 from '../static/house/household3D/02_09_02/08.jpg';
import household3D_02_09_02_09 from '../static/house/household3D/02_09_02/09.jpg';
import household3D_02_09_02_10 from '../static/house/household3D/02_09_02/10.jpg';
import household3D_02_09_02_11 from '../static/house/household3D/02_09_02/11.jpg';
import household3D_02_09_02_12 from '../static/house/household3D/02_09_02/12.jpg';
import household3D_02_09_02_13 from '../static/house/household3D/02_09_02/13.jpg';
import household3D_02_09_02_14 from '../static/house/household3D/02_09_02/14.jpg';
import household3D_02_09_02_15 from '../static/house/household3D/02_09_02/15.jpg';
import household3D_02_09_02_16 from '../static/house/household3D/02_09_02/16.jpg';
import household3D_02_09_02_17 from '../static/house/household3D/02_09_02/17.jpg';
import household3D_02_09_02_18 from '../static/house/household3D/02_09_02/18.jpg';
import household3D_02_09_02_19 from '../static/house/household3D/02_09_02/19.jpg';
import household3D_02_09_02_20 from '../static/house/household3D/02_09_02/20.jpg';
import household3D_02_09_02_21 from '../static/house/household3D/02_09_02/21.jpg';
import household3D_02_09_02_22 from '../static/house/household3D/02_09_02/22.jpg';
import household3D_02_09_02_23 from '../static/house/household3D/02_09_02/23.jpg';
import household3D_02_09_02_24 from '../static/house/household3D/02_09_02/24.jpg';
import household3D_02_09_02_25 from '../static/house/household3D/02_09_02/25.jpg';
import household3D_02_09_02_26 from '../static/house/household3D/02_09_02/26.jpg';
import household3D_02_09_02_27 from '../static/house/household3D/02_09_02/27.jpg';
import household3D_02_09_02_28 from '../static/house/household3D/02_09_02/28.jpg';
import household3D_02_09_02_29 from '../static/house/household3D/02_09_02/29.jpg';
import household3D_02_09_02_30 from '../static/house/household3D/02_09_02/30.jpg';
import household3D_02_09_02_31 from '../static/house/household3D/02_09_02/31.jpg';
import household3D_02_09_02_32 from '../static/house/household3D/02_09_02/32.jpg';
import household3D_02_09_02_33 from '../static/house/household3D/02_09_02/33.jpg';
import household3D_02_09_02_34 from '../static/house/household3D/02_09_02/34.jpg';
import household3D_02_09_02_35 from '../static/house/household3D/02_09_02/35.jpg';

import household3D_02_03_02_up_00 from '../static/house/household3D/02_03_02/up/00.jpg';
import household3D_02_03_02_up_01 from '../static/house/household3D/02_03_02/up/01.jpg';
import household3D_02_03_02_up_02 from '../static/house/household3D/02_03_02/up/02.jpg';
import household3D_02_03_02_up_03 from '../static/house/household3D/02_03_02/up/03.jpg';
import household3D_02_03_02_up_04 from '../static/house/household3D/02_03_02/up/04.jpg';
import household3D_02_03_02_up_05 from '../static/house/household3D/02_03_02/up/05.jpg';
import household3D_02_03_02_up_06 from '../static/house/household3D/02_03_02/up/06.jpg';
import household3D_02_03_02_up_07 from '../static/house/household3D/02_03_02/up/07.jpg';
import household3D_02_03_02_up_08 from '../static/house/household3D/02_03_02/up/08.jpg';
import household3D_02_03_02_up_09 from '../static/house/household3D/02_03_02/up/09.jpg';
import household3D_02_03_02_up_10 from '../static/house/household3D/02_03_02/up/10.jpg';
import household3D_02_03_02_up_11 from '../static/house/household3D/02_03_02/up/11.jpg';
import household3D_02_03_02_up_12 from '../static/house/household3D/02_03_02/up/12.jpg';
import household3D_02_03_02_up_13 from '../static/house/household3D/02_03_02/up/13.jpg';
import household3D_02_03_02_up_14 from '../static/house/household3D/02_03_02/up/14.jpg';
import household3D_02_03_02_up_15 from '../static/house/household3D/02_03_02/up/15.jpg';
import household3D_02_03_02_up_16 from '../static/house/household3D/02_03_02/up/16.jpg';
import household3D_02_03_02_up_17 from '../static/house/household3D/02_03_02/up/17.jpg';
import household3D_02_03_02_up_18 from '../static/house/household3D/02_03_02/up/18.jpg';
import household3D_02_03_02_up_19 from '../static/house/household3D/02_03_02/up/19.jpg';
import household3D_02_03_02_up_20 from '../static/house/household3D/02_03_02/up/20.jpg';
import household3D_02_03_02_up_21 from '../static/house/household3D/02_03_02/up/21.jpg';
import household3D_02_03_02_up_22 from '../static/house/household3D/02_03_02/up/22.jpg';
import household3D_02_03_02_up_23 from '../static/house/household3D/02_03_02/up/23.jpg';
import household3D_02_03_02_up_24 from '../static/house/household3D/02_03_02/up/24.jpg';
import household3D_02_03_02_up_25 from '../static/house/household3D/02_03_02/up/25.jpg';
import household3D_02_03_02_up_26 from '../static/house/household3D/02_03_02/up/26.jpg';
import household3D_02_03_02_up_27 from '../static/house/household3D/02_03_02/up/27.jpg';
import household3D_02_03_02_up_28 from '../static/house/household3D/02_03_02/up/28.jpg';
import household3D_02_03_02_up_29 from '../static/house/household3D/02_03_02/up/29.jpg';
import household3D_02_03_02_up_30 from '../static/house/household3D/02_03_02/up/30.jpg';
import household3D_02_03_02_up_31 from '../static/house/household3D/02_03_02/up/31.jpg';
import household3D_02_03_02_up_32 from '../static/house/household3D/02_03_02/up/32.jpg';
import household3D_02_03_02_up_33 from '../static/house/household3D/02_03_02/up/33.jpg';
import household3D_02_03_02_up_34 from '../static/house/household3D/02_03_02/up/34.jpg';
import household3D_02_03_02_up_35 from '../static/house/household3D/02_03_02/up/35.jpg';

import household3D_02_03_02_down_00 from '../static/house/household3D/02_03_02/down/00.jpg';
import household3D_02_03_02_down_01 from '../static/house/household3D/02_03_02/down/01.jpg';
import household3D_02_03_02_down_02 from '../static/house/household3D/02_03_02/down/02.jpg';
import household3D_02_03_02_down_03 from '../static/house/household3D/02_03_02/down/03.jpg';
import household3D_02_03_02_down_04 from '../static/house/household3D/02_03_02/down/04.jpg';
import household3D_02_03_02_down_05 from '../static/house/household3D/02_03_02/down/05.jpg';
import household3D_02_03_02_down_06 from '../static/house/household3D/02_03_02/down/06.jpg';
import household3D_02_03_02_down_07 from '../static/house/household3D/02_03_02/down/07.jpg';
import household3D_02_03_02_down_08 from '../static/house/household3D/02_03_02/down/08.jpg';
import household3D_02_03_02_down_09 from '../static/house/household3D/02_03_02/down/09.jpg';
import household3D_02_03_02_down_10 from '../static/house/household3D/02_03_02/down/10.jpg';
import household3D_02_03_02_down_11 from '../static/house/household3D/02_03_02/down/11.jpg';
import household3D_02_03_02_down_12 from '../static/house/household3D/02_03_02/down/12.jpg';
import household3D_02_03_02_down_13 from '../static/house/household3D/02_03_02/down/13.jpg';
import household3D_02_03_02_down_14 from '../static/house/household3D/02_03_02/down/14.jpg';
import household3D_02_03_02_down_15 from '../static/house/household3D/02_03_02/down/15.jpg';
import household3D_02_03_02_down_16 from '../static/house/household3D/02_03_02/down/16.jpg';
import household3D_02_03_02_down_17 from '../static/house/household3D/02_03_02/down/17.jpg';
import household3D_02_03_02_down_18 from '../static/house/household3D/02_03_02/down/18.jpg';
import household3D_02_03_02_down_19 from '../static/house/household3D/02_03_02/down/19.jpg';
import household3D_02_03_02_down_20 from '../static/house/household3D/02_03_02/down/20.jpg';
import household3D_02_03_02_down_21 from '../static/house/household3D/02_03_02/down/21.jpg';
import household3D_02_03_02_down_22 from '../static/house/household3D/02_03_02/down/22.jpg';
import household3D_02_03_02_down_23 from '../static/house/household3D/02_03_02/down/23.jpg';
import household3D_02_03_02_down_24 from '../static/house/household3D/02_03_02/down/24.jpg';
import household3D_02_03_02_down_25 from '../static/house/household3D/02_03_02/down/25.jpg';
import household3D_02_03_02_down_26 from '../static/house/household3D/02_03_02/down/26.jpg';
import household3D_02_03_02_down_27 from '../static/house/household3D/02_03_02/down/27.jpg';
import household3D_02_03_02_down_28 from '../static/house/household3D/02_03_02/down/28.jpg';
import household3D_02_03_02_down_29 from '../static/house/household3D/02_03_02/down/29.jpg';
import household3D_02_03_02_down_30 from '../static/house/household3D/02_03_02/down/30.jpg';
import household3D_02_03_02_down_31 from '../static/house/household3D/02_03_02/down/31.jpg';
import household3D_02_03_02_down_32 from '../static/house/household3D/02_03_02/down/32.jpg';
import household3D_02_03_02_down_33 from '../static/house/household3D/02_03_02/down/33.jpg';
import household3D_02_03_02_down_34 from '../static/house/household3D/02_03_02/down/34.jpg';
import household3D_02_03_02_down_35 from '../static/house/household3D/02_03_02/down/35.jpg';

class HouseMobx {
	@observable navs = [{
		yard: '叁号院',
		blocks: [
			// {
			// 	block: '一幢',
			// 	household: {
			// 		names: ['01', '02', '03', '05', '06', '07', '08', '09'],
			// 		planes: [plane_03_01_01, plane_03_01_02, plane_03_01_03, plane_03_01_05, plane_03_01_06, plane_03_01_07, plane_03_01_08, plane_03_01_09],
			// 		describes: [{
			// 			block: '01',
			// 			area: '116.48m²',
			// 			structure: '3房2厅2卫',
			// 			templateRoom: './vr/room_01/index.html',
			// 			household3Ds: [
			// 				household3D_03_01_01_00, household3D_03_01_01_01, household3D_03_01_01_02, household3D_03_01_01_03, household3D_03_01_01_04,
			// 				household3D_03_01_01_05, household3D_03_01_01_06, household3D_03_01_01_07, household3D_03_01_01_08, household3D_03_01_01_09,
			// 				household3D_03_01_01_10, household3D_03_01_01_11, household3D_03_01_01_12, household3D_03_01_01_13, household3D_03_01_01_14,
			// 				household3D_03_01_01_15, household3D_03_01_01_16, household3D_03_01_01_17, household3D_03_01_01_18, household3D_03_01_01_19,
			// 				household3D_03_01_01_20, household3D_03_01_01_21, household3D_03_01_01_22, household3D_03_01_01_23, household3D_03_01_01_24,
			// 				household3D_03_01_01_25, household3D_03_01_01_26, household3D_03_01_01_27, household3D_03_01_01_28, household3D_03_01_01_29,
			// 				household3D_03_01_01_30, household3D_03_01_01_31, household3D_03_01_01_32, household3D_03_01_01_33, household3D_03_01_01_34,
			// 				household3D_03_01_01_35]
			// 		}, {
			// 			block: '02',
			// 			area: '119.09m²',
			// 			structure: '3房2厅2卫',
			// 			templateRoom: './vr/room_02/index.html',
			// 			household3Ds: [
			// 				household3D_03_01_02_00, household3D_03_01_02_01, household3D_03_01_02_02, household3D_03_01_02_03, household3D_03_01_02_04,
			// 				household3D_03_01_02_05, household3D_03_01_02_06, household3D_03_01_02_07, household3D_03_01_02_08, household3D_03_01_02_09,
			// 				household3D_03_01_02_10, household3D_03_01_02_11, household3D_03_01_02_12, household3D_03_01_02_13, household3D_03_01_02_14,
			// 				household3D_03_01_02_15, household3D_03_01_02_16, household3D_03_01_02_17, household3D_03_01_02_18, household3D_03_01_02_19,
			// 				household3D_03_01_02_20, household3D_03_01_02_21, household3D_03_01_02_22, household3D_03_01_02_23, household3D_03_01_02_24,
			// 				household3D_03_01_02_25, household3D_03_01_02_26, household3D_03_01_02_27, household3D_03_01_02_28, household3D_03_01_02_29,
			// 				household3D_03_01_02_30, household3D_03_01_02_31, household3D_03_01_02_32, household3D_03_01_02_33, household3D_03_01_02_34,
			// 				household3D_03_01_02_35]
			// 		}, {
			// 			block: '03',
			// 			area: '118.76m²',
			// 			structure: '3房2厅2卫'
			// 		}, {
			// 			block: '05',
			// 			area: '114.59m²',
			// 			structure: '3房2厅2卫'
			// 		}, {
			// 			block: '06',
			// 			area: '114m²',
			// 			structure: '3房2厅2卫'
			// 		}, {
			// 			block: '07',
			// 			area: '115.04m²',
			// 			structure: '3房2厅2卫'
			// 		}, {
			// 			block: '08',
			// 			area: '143.29m²',
			// 			structure: '4房2厅3卫'
			// 		}, {
			// 			block: '09',
			// 			area: '132.02m²',
			// 			structure: '4房2厅2卫'
			// 		}]
			// 	}
			// },
			{
				block: '五幢',
				household: {
					names: ['01', '02', '03', '05', '06', '07', '08', '09'],
					planes: [plane_03_05_01, plane_03_05_02, plane_03_05_03, plane_03_05_05, plane_03_05_06, plane_03_05_07, plane_03_05_08, plane_03_05_09],
					describes: [{
						block: '01',
						area: '90.84m²',
						structure: '3房2厅2卫'
					}, {
						block: '02',
						area: '91.69m²',
						structure: '3房2厅2卫',
					}, {
						block: '03',
						area: '94.08m²',
						structure: '3房2厅2卫'
					}, {
						block: '05',
						area: '108.02㎡',
						structure: '4房2厅2卫'
					}, {
						block: '06',
						area: '90.28m²',
						structure: '3房2厅2卫'
					}, {
						block: '07',
						area: '94.09m²',
						structure: '3房2厅2卫'
					}, {
						block: '08',
						area: '97.35m²',
						structure: '3房2厅2卫'
					}, {
						block: '09',
						area: '124.85m²',
						structure: '4房2厅2卫'
					}]
				}
			},
			// {
			// 	block: '七幢',
			// 	household: {
			// 		names: ['01', '02', '03', '05', '06', '07', '08', '09'],
			// 		planes: [plane_03_07_01, plane_03_07_02, plane_03_07_03, plane_03_07_05, plane_03_07_06, plane_03_07_07, plane_03_07_08, plane_03_07_09],
			// 		describes: [{
			// 			block: '01',
			// 			area: '135.10m²',
			// 			structure: '4房2厅2卫',
			// 		}, {
			// 			block: '02',
			// 			area: '120.64m²',
			// 			structure: '3房2厅2卫',
			// 		}, {
			// 			block: '03',
			// 			area: '115.52m²',
			// 			structure: '3房2厅2卫'
			// 		}, {
			// 			block: '05',
			// 			area: '117.30m²',
			// 			structure: '3房2厅2卫'
			// 		}, {
			// 			block: '06',
			// 			area: '115.78m²',
			// 			structure: '3房2厅2卫'
			// 		}, {
			// 			block: '07',
			// 			area: '114.02m²',
			// 			structure: '3房2厅2卫'
			// 		}, {
			// 			block: '08',
			// 			area: '153.51m²',
			// 			structure: '4房2厅3卫'
			// 		}, {
			// 			block: '09',
			// 			area: '137.93m²',
			// 			structure: '4房2厅2卫'
			// 		}]
			// 	}
			// }
		]
	}, {
		yard: '贰号院',
		blocks: [
			// {
			// 	block: '三幢',
			// 	household: {
			// 		names: ['02'],
			// 		planes: [plane_02_03_02_up],
			// 		describes: [{
			// 			block: '02',
			// 			area: '406.74m²',
			// 			structure: '7房3厅5卫',
			// 			templateRoom: './vr/room_02_03_02/index.html',
			// 			household3Ds: [
			// 				household3D_02_03_02_up_00, household3D_02_03_02_up_01, household3D_02_03_02_up_02, household3D_02_03_02_up_03, household3D_02_03_02_up_04,
			// 				household3D_02_03_02_up_05, household3D_02_03_02_up_06, household3D_02_03_02_up_07, household3D_02_03_02_up_08, household3D_02_03_02_up_09,
			// 				household3D_02_03_02_up_10, household3D_02_03_02_up_11, household3D_02_03_02_up_12, household3D_02_03_02_up_13, household3D_02_03_02_up_14,
			// 				household3D_02_03_02_up_15, household3D_02_03_02_up_16, household3D_02_03_02_up_17, household3D_02_03_02_up_18, household3D_02_03_02_up_19,
			// 				household3D_02_03_02_up_20, household3D_02_03_02_up_21, household3D_02_03_02_up_22, household3D_02_03_02_up_23, household3D_02_03_02_up_24,
			// 				household3D_02_03_02_up_25, household3D_02_03_02_up_26, household3D_02_03_02_up_27, household3D_02_03_02_up_28, household3D_02_03_02_up_29,
			// 				household3D_02_03_02_up_30, household3D_02_03_02_up_31, household3D_02_03_02_up_32, household3D_02_03_02_up_33, household3D_02_03_02_up_34,
			// 				household3D_02_03_02_up_35],
			// 			floors: [{
			// 				name: '上层',
			// 				plane: plane_02_03_02_up,
			// 				household3D: [
			// 					household3D_02_03_02_up_00, household3D_02_03_02_up_01, household3D_02_03_02_up_02, household3D_02_03_02_up_03, household3D_02_03_02_up_04,
			// 					household3D_02_03_02_up_05, household3D_02_03_02_up_06, household3D_02_03_02_up_07, household3D_02_03_02_up_08, household3D_02_03_02_up_09,
			// 					household3D_02_03_02_up_10, household3D_02_03_02_up_11, household3D_02_03_02_up_12, household3D_02_03_02_up_13, household3D_02_03_02_up_14,
			// 					household3D_02_03_02_up_15, household3D_02_03_02_up_16, household3D_02_03_02_up_17, household3D_02_03_02_up_18, household3D_02_03_02_up_19,
			// 					household3D_02_03_02_up_20, household3D_02_03_02_up_21, household3D_02_03_02_up_22, household3D_02_03_02_up_23, household3D_02_03_02_up_24,
			// 					household3D_02_03_02_up_25, household3D_02_03_02_up_26, household3D_02_03_02_up_27, household3D_02_03_02_up_28, household3D_02_03_02_up_29,
			// 					household3D_02_03_02_up_30, household3D_02_03_02_up_31, household3D_02_03_02_up_32, household3D_02_03_02_up_33, household3D_02_03_02_up_34,
			// 					household3D_02_03_02_up_35],
			// 			}, {
			// 				name: '下层',
			// 				plane: plane_02_03_02_down,
			// 				household3D: [
			// 					household3D_02_03_02_down_00, household3D_02_03_02_down_01, household3D_02_03_02_down_02, household3D_02_03_02_down_03, household3D_02_03_02_down_04,
			// 					household3D_02_03_02_down_05, household3D_02_03_02_down_06, household3D_02_03_02_down_07, household3D_02_03_02_down_08, household3D_02_03_02_down_09,
			// 					household3D_02_03_02_down_10, household3D_02_03_02_down_11, household3D_02_03_02_down_12, household3D_02_03_02_down_13, household3D_02_03_02_down_14,
			// 					household3D_02_03_02_down_15, household3D_02_03_02_down_16, household3D_02_03_02_down_17, household3D_02_03_02_down_18, household3D_02_03_02_down_19,
			// 					household3D_02_03_02_down_20, household3D_02_03_02_down_21, household3D_02_03_02_down_22, household3D_02_03_02_down_23, household3D_02_03_02_down_24,
			// 					household3D_02_03_02_down_25, household3D_02_03_02_down_26, household3D_02_03_02_down_27, household3D_02_03_02_down_28, household3D_02_03_02_down_29,
			// 					household3D_02_03_02_down_30, household3D_02_03_02_down_31, household3D_02_03_02_down_32, household3D_02_03_02_down_33, household3D_02_03_02_down_34,
			// 					household3D_02_03_02_down_35]
			// 			}]
			// 		}]
			// 	}
			// },
			{
				block: '五幢',
				household: {
					names: ['01', '02'],
					planes: [plane_02_05_01, plane_02_05_02],
					describes: [{
						block: '01',
						area: '275m²',
						structure: '5房2厅4卫',
					}, {
						block: '02',
						area: '283m²',
						structure: '5房2厅4卫',
					}]
				}
			},
			// {
			// 	block: '九幢',
			// 	household: {
			// 		names: ['02'],
			// 		planes: [plane_02_09_02],
			// 		describes: [{
			// 			block: '02',
			// 			area: '241m²',
			// 			structure: '5房2厅4卫',
			// 			templateRoom: './vr/room_02_09_02/index.html',
			// 			household3Ds: [
			// 				household3D_02_09_02_00, household3D_02_09_02_01, household3D_02_09_02_02, household3D_02_09_02_03, household3D_02_09_02_04,
			// 				household3D_02_09_02_05, household3D_02_09_02_06, household3D_02_09_02_07, household3D_02_09_02_08, household3D_02_09_02_09,
			// 				household3D_02_09_02_10, household3D_02_09_02_11, household3D_02_09_02_12, household3D_02_09_02_13, household3D_02_09_02_14,
			// 				household3D_02_09_02_15, household3D_02_09_02_16, household3D_02_09_02_17, household3D_02_09_02_18, household3D_02_09_02_19,
			// 				household3D_02_09_02_20, household3D_02_09_02_21, household3D_02_09_02_22, household3D_02_09_02_23, household3D_02_09_02_24,
			// 				household3D_02_09_02_25, household3D_02_09_02_26, household3D_02_09_02_27, household3D_02_09_02_28, household3D_02_09_02_29,
			// 				household3D_02_09_02_30, household3D_02_09_02_31, household3D_02_09_02_32, household3D_02_09_02_33, household3D_02_09_02_34,
			// 				household3D_02_09_02_35]
			// 		}]
			// 	}
			// }
		]
	}, {
		yard: '壹号院',
		blocks: [{
			block: '一幢',
			household: {
				names: ['A1', 'A5', 'A7'],
				planes: [plane_01_A1_102, plane_01_A5_102, plane_01_A7_102],
				describes: [{
					block: 'A1',
					area: '534.80m²',
					structure: '6房2厅7卫',
					floors: [{
						name: '梯屋',
						plane: plane_01_A1_102
					}, {
						name: '三层',
						plane: plane_01_A1_03
					}, {
						name: '二层',
						plane: plane_01_A1_02
					}, {
						name: '一层',
						plane: plane_01_A1_01
					}, {
						name: '负一层',
						plane: plane_01_A1__01
					}],
				}, {
					block: 'A5',
					area: '453.48m²',
					structure: '4房2厅6卫',
					floors: [{
						name: '梯屋',
						plane: plane_01_A5_102
					}, {
						name: '三层',
						plane: plane_01_A5_03
					}, {
						name: '二层',
						plane: plane_01_A5_02
					}, {
						name: '一层',
						plane: plane_01_A5_01
					}, {
						name: '负一层',
						plane: plane_01_A5__01
					}],
				}, {
					block: 'A7',
					area: '408.37m²',
					structure: '4房2厅6卫',
					floors: [{
						name: '梯屋',
						plane: plane_01_A7_102
					}, {
						name: '三层',
						plane: plane_01_A7_03
					}, {
						name: '二层',
						plane: plane_01_A7_02
					}, {
						name: '一层',
						plane: plane_01_A7_01
					}, {
						name: '负一层',
						plane: plane_01_A7__01
					}],
				}]
			}
		}]
	}];
	@observable selectYardIndex = ZERO;   // 选中院子的索引
	@observable selectBlockIndex = ZERO;  //选中幢的索引
	@observable selectHouseholdIndex = ZERO; //选中户型的索引
	@observable selectFloorIndex = ZERO; //选中楼层的索引
	@observable watchButtons = ['观看样板间', '观看3D户型'];
	@observable showTemplateRoom = false;  // 显示样板间
	@observable show3DHousehold = false;  // 显示3d户型
	@observable curr3DHouseholdIndex = ZERO; // 当前3D户型的图片的索引
	@observable startSite = ZERO;  // 手指刚接触的位置
	@observable endSite = ZERO;  // 手指停止的位置
	@observable backIcon = back;  // 返回按钮
}

export default HouseMobx;